import * as React from "react";
import { forwardRef, memo } from "react";
const SvgQa = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1400 550", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#8d1b3d", d: "M0 0h1400v550H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M400 550H0V0h400l100 30.556L400 61.11l100 30.556-100 30.555 100 30.556-100 30.555 100 30.556-100 30.555L500 275l-100 30.556 100 30.555-100 30.556 100 30.555-100 30.556 100 30.555-100 30.556 100 30.555z", fill: "#fff" }));
const ForwardRef = forwardRef(SvgQa);
const Memo = memo(ForwardRef);
export default Memo;
